<!--
 * @Author: LeeHuiXian
 * @version: 
 * @Date: 2020-04-27 12:13:55
 * @LastEditors: LeeHuiXian
 * @LastEditTime: 2020-10-14 16:28:03
 * @FilePath: /goldenSalesMobile/src/views/LayOut/index.vue
 * @Description: 分销员tab页的layout
-->
<template>
  <div class='layout'>
    <router-view />
    <my-tab-bar />
  </div>
</template>

<script>
import MyTabBar from '@/components/MyTabBar/index.vue'
export default {
  data() {
    return {
      
    }
  },
  components:{
    MyTabBar
  },
  created() {

  }
}
</script>

<style lang='scss' scoped></style>

